// importando estilização do componente
import { useState, useEffect } from 'react'
import { Styled } from './Styled';
import icons from '../../img/icons/icons';
import { Footer } from '../../shared/components/layout/footer/Footer';
import { Header } from '../../shared/components/layout/header/Header';
import { StoreStatus } from '../../shared/components/layout/storeStatus/StoreStatus';


export const Sobre: React.FC = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageIndex, setModalImageIndex] = useState(0);
    const images = [icons.Fachada, icons.recpecao, icons.auditorio, icons.laboratorio];

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // Ativa o carrousel quando menor que 1200px
        if (windowWidth < 1200) {
            const interval = setInterval(() => {
                setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
            }, 3000);

            return () => clearInterval(interval);
        } else {
            // Reset index quando voltar para desktop
            setCurrentImageIndex(0);
        }
    }, [windowWidth]);

    // Calcula o percentual de deslocamento baseado na largura da tela
    const getTranslateValue = () => {
        if (windowWidth >= 1200) return 0; // Desktop: sem movimento
        if (windowWidth >= 900) return currentImageIndex * 50; // Tablet grande: 2 imagens (50% cada)
        if (windowWidth >= 768) return currentImageIndex * 33.333; // Tablet: 3 imagens (33.333% cada)
        return currentImageIndex * 100; // Mobile: 1 imagem (100%)
    };

    const openModal = (index: number) => {
        setModalImageIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const nextImage = () => {
        setModalImageIndex((prev) => (prev + 1) % images.length);
    };

    const prevImage = () => {
        setModalImageIndex((prev) => (prev - 1 + images.length) % images.length);
    };

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (!isModalOpen) return;
            if (e.key === 'Escape') closeModal();
            if (e.key === 'ArrowRight') nextImage();
            if (e.key === 'ArrowLeft') prevImage();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isModalOpen]);

    return (
        <Styled.Content>
            <Header />
            <div className='BannerArea'>
                <div className='BannerFixed'>
                    <img src={icons.BemVindo} alt="Bem Vindo" />
                </div>
                <div className='ImgCarrousel'>
                    <div 
                        className='CarrouselContainer'
                        style={{ 
                            transform: `translateX(-${getTranslateValue()}%)` 
                        }}
                    >
                        {images.map((img, index) => (
                            <img 
                                key={index}
                                src={img} 
                                alt={`Imagem ${index + 1}`}
                                onClick={() => openModal(index)}
                                style={{ cursor: 'pointer' }}
                            />
                        ))}
                    </div>
                </div>
            </div>

            {/* Modal de Visualização de Imagens */}
            {isModalOpen && (
                <div className='ImageModal' onClick={closeModal}>
                    <button className='CloseButton' onClick={closeModal}>✕</button>
                    <button className='NavButton PrevButton' onClick={(e) => { e.stopPropagation(); prevImage(); }}>‹</button>
                    <button className='NavButton NextButton' onClick={(e) => { e.stopPropagation(); nextImage(); }}>›</button>
                    <img 
                        src={images[modalImageIndex]} 
                        alt={`Imagem ${modalImageIndex + 1}`}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
            <div className='InfoArea'>
                <div className='Card'>
                    <span className='Title'>
                        SOBRE NÓS
                    </span>
                    <p>
                        Desde 2004 ministrando Cursos em diversas áreas
                        de conhecimento profissionalizantes em Palmeira das Missões  e Região, com
                        sua sede própria em Palmeira das Missões, e tem como
                        principal objetivo de Ajudar as pessoas a alcançar seus
                        objetivos e sonhos através da Qualificação Profissional.
                        Proporcionando aos seus alunos excelentes cursos nas mais
                        diversas áreas de conhecimento. Seus valores são a busca
                        pela excelência, a inovação constante, o comprometimento
                        com o cliente e a transparência nos serviços prestados.
                    </p>
                </div>

                <div className='Card'>
                    <span className='Title'>
                        MÉTODO DE ENSINO
                    </span>
                    <p>
                        Desde 2004 ministrando Cursos em diversas áreas
                        de conhecimento profissionalizantes em Palmeira das Missões  e Região, com
                        sua sede própria em Palmeira das Missões, e tem como
                        principal objetivo de Ajudar as pessoas a alcançar seus
                        objetivos e sonhos através da Qualificação Profissional.
                        Proporcionando aos seus alunos excelentes cursos nas mais
                        diversas áreas de conhecimento. Seus valores são a busca
                        pela excelência, a inovação constante, o comprometimento
                        com o cliente e a transparência nos serviços prestados.
                    </p>
                </div>

                <div className='Card'>
                    <span className='Title'>
                        BENEFÍCIOS
                    </span>
                    <ul>
                        <li>
                            Inscrição no programa <strong>Emprega Agora</strong> com <strong>encaminhamento</strong> ao <strong>mercado de trabalho</strong>.
                        </li>
                        <li>
                            Alto índice de <strong>empregabilidade</strong> pós-curso.
                        </li>
                        <li>
                            Salas de aula climatizadas equipadas com projetor garantindo o conforto e aprendizagem do aluno.
                        </li>
                        <li>
                            Material didático exclusivo com departamento pedagógico próprio.
                        </li>
                        <li>
                            <strong>Certificado de conclusão</strong> reconhecido em todo o território Nacional.
                        </li>
                        <li>
                            Professores altamente qualificados.
                        </li>
                    </ul>
                </div>

                <div className='Card AreasCard'>
                    <span className='Title'>
                        ÁREAS DE ENSINO
                    </span>
                    <div className='ProfissoesImage'>
                        <img src={icons.Profissoes} alt="Profissionais" />
                    </div>
                    <div className='AreasGrid'>
                        <div className='AreaItem'>
                            <img src={icons.tecnologia} alt="Tecnologia" />
                            <span>Tecnologia</span>
                        </div>
                        <div className='AreaItem'>
                            <img src={icons.admin} alt="Administrativo" />
                            <span>Administrativo</span>
                        </div>
                        <div className='AreaItem'>
                            <img src={icons.saude} alt="Saúde" />
                            <span>Saúde</span>
                        </div>
                        <div className='AreaItem'>
                            <img src={icons.beleza} alt="Beleza" />
                            <span>Beleza</span>
                        </div>
                        <div className='AreaItem'>
                            <img src={icons.mecanica} alt="Mecânica" />
                            <span>Mecânica</span>
                        </div>
                        <div className='AreaItem'>
                            <img src={icons.idioma} alt="Idioma" />
                            <span>Idioma</span>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Styled.Content>
    )
}
// aqui estamos exportando nosso componente
